import {Locale, useConfig} from '@aboutyou/config';
import React from 'react';

interface SchemaDataType {
  alternateName: string;
  description: string;
  specialty: string;
  relatedLink: string;
  about: string;
  url: string;
  publisher: {email: string; url: string};
}

const SchemaData: Record<number, Partial<Record<Locale, SchemaDataType>>> = {
  106117: {
    [Locale.en_AT]: {
      alternateName: 'ABOUT YOU AT',
      description:
        "ABOUT YOU is one of Europe's leading online fashion retailers, offering the latest trends from thousands of brands for women, men, and kids.",
      specialty:
        'ABOUT YOU specialices in digital fashion retail, combining technology and personalisation to create a seamless and inspiring mobile-first shopping experience.',
      relatedLink: 'https://corporate.aboutyou.de/en/about-us',
      about:
        'Founded in 2014, ABOUT YOU is Hamburg’s first unicorn and now one of Germany’s largest fashion e-tailers. We are committed to digitalising the shopping experience while fostering a diverse, inclusive, and forward-thinking work culture.',
      url: 'https://en.aboutyou.at/',
      publisher: {
        email: 'customerservice@aboutyou.at',
        url: 'https://en.aboutyou.at/',
      },
    },
    [Locale.de_AT]: {
      alternateName: 'ABOUT YOU AT',
      description:
        'ABOUT YOU ist einer der führenden europäischen Modehändler und bietet die neuesten Trends von Tausenden von Marken für Damen, Herren und Kinder an.',
      specialty:
        'ABOUT YOU ist ein Online-Modehändler, der Technologien und Personalisierung kombiniert, um ein reibungsloses und inspirierendes Shopping-Erlebnis, besonders auf mobilen Endgeräten, zu gewährleisten.',
      relatedLink: 'https://corporate.aboutyou.de/de/about-us',
      about:
        'ABOUT YOU wurde 2014 gegründet und erreichte als erstes Hamburger Unternehmen eine Milliardenbewertung. Heute zählt er zu den größten deutschen Online-Modehändler. Mit einer diversen, inklusiven und zukunftsorientierten Arbeitskultur treiben wir die Digitalisierung des Shopping-Erlebnisses voran.',
      url: 'https://www.aboutyou.at/',
      publisher: {
        email: 'kundenservice@aboutyou.at',
        url: 'https://aboutyou.at/',
      },
    },
  },
};

export const AboutUsJsonLd = ({pageId}: {pageId: number}) => {
  const {locale} = useConfig();

  const pageData = SchemaData[pageId];
  if (!pageData) {
    return null;
  }

  const currentSchema = pageData[locale];

  if (currentSchema) {
    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: 'ABOUT YOU',
            ...currentSchema,
            publisher: {
              ...currentSchema.publisher,
              '@type': 'Organization',
              name: 'ABOUT YOU SE & Co. KG',
              logo: 'https://corporate.aboutyou.de/app/uploads/2023/10/AY-Black_White-Letters_RGB.png',
              sameAs: [
                'https://www.aboutyou.at/',
                'https://www.facebook.com/aboutyouglobal/',
                'https://www.instagram.com/aboutyoude',
                'https://twitter.com/aboutyou_com',
                'https://www.youtube.com/@aboutyou_com',
                'https://www.pinterest.com/aboutyoude',
                'https://www.tiktok.com/@aboutyou',
              ],
              image:
                'https://corporate.aboutyou.de/app/uploads/2023/10/AY-Black_White-Letters_RGB.png',
              address: {
                '@type': 'PostalAddress',
                streetAddress: 'Domstraße 10',
                addressLocality: 'Hamburg',
                addressRegion: 'Hansestadt Hamburg',
                postalCode: '20095',
                addresscountry: 'DE',
              },
            },
          }),
        }}
      ></script>
    );
  }

  return null;
};
